import { message, notification } from 'antd'
import { Type } from '@utils/tool'
import { showsubscribedTips } from '@ui-pc/Subscription'
import { request } from '@utils/request'

/**
 *  获取订单详情-旧版，暂时不用了
 */
export const getOrderDetail = (param: string, isStatement = false) => {
  return request
    .post(
      '/order/trackOrderInfo',
      isStatement ? { orderToken: param } : { ordersId: param }
    )
    .then((res) => {
      if (res.data?.isSubscriptionPopup) {
        showsubscribedTips()
      }
      return res.data
    })
    .catch((err) => {
      notification.error({
        message: 'Failure!',
        description: `${err?.message}`,
        duration: 5
      })
      throw new Error(err)
    })
}

/**
 *  支付结果页获取支付结果信息-新接口
 */
export const getSuccessOrderInfo = (param = {}) => {
  return request
    .post('/order/successOrderInfo', { ...param })
    .then((res) => {
      const newData = Type.isEmpty(res?.data) ? {} : res?.data
      if (newData?.isSubscriptionPopup) {
        showsubscribedTips()
      }
      return {
        code: res.code,
        message: res.message,
        ...newData
      }
    })
    .catch((err) => {
      notification.error({
        message: 'Failure!',
        description: `${err?.message}`,
        duration: 5
      })
      throw new Error(err)
    })
}
